import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { MyMonitoringService } from '../../services/logging.service';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string,
  displayName?: string,
  jobTitle?: string,
  officeLocation?: string
}

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class ProfileComponent implements OnInit {
  profile!: ProfileType;

  constructor( private http: HttpClient,private authService: MsalService,
    private monotoringService: MyMonitoringService,) { 
    
  }

  ngOnInit() {
    this.getProfile();
    this.getAccessTokenAndCallGraphAPI();
  }

  getProfile() {
    this.http.get(GRAPH_ENDPOINT)
      .subscribe(profile => {
        this.profile = profile;
      });
          
  }

  getAccessTokenAndCallGraphAPI(){
    this.authService.acquireTokenSilent({
      scopes: ['GroupMember.Read.All']
    }).subscribe(result=>{
      //console.log(result.accessToken);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          Authorization: 'Bearer '+ result.accessToken
          
        })}

      const reqBody = {
        "securityEnabledOnly": true
      }
      //this.http.post("https://graph.microsoft.com/v1.0/users/vijay.andugula@centerpointenergy.com/getMemberGroups",reqBody,httpOptions).toPromise().then(result=>{console.log(result)});
    })
  }
}
